export const env = {
  // apiHost: "http://localhost:3033/",
  // frontUrl: "http://localhost:3000/",
  apiHost: "https://crymadx.io:3033/",
  frontUrl: "https://crymadx.io/",
  upload_preset: "crymadx",
  cloud_name: "daipuhrqy",
};
